import React from 'react';
import ArtifactsPage from './ArtifactsPage';
const ArtifactDetailPage: React.FC = () => <ArtifactsPage />;
export default ArtifactDetailPage;
